import { SITE } from '@/routes/config/paths';
import {
  PasswordReset,
  VerifyEmail,
  TokenLogin,
  ProfileEdit,
  Profile,
  ProfileNotificationSettings,
  OpenASK,
  AuthWall,
  BundleRoute,
} from '@/routes/config/elements';

/**
 * Static site routes. Does not include:
 * - profile/:id (conditional element: LoginBox vs Profile, handled in SiteRoutes)
 * - Dynamic pages from getPagesArray() (handled in SiteRoutes)
 */
export const siteStaticRoutes = [
  { path: SITE.RESET, Component: PasswordReset },
  { path: SITE.VERIFY, Component: VerifyEmail },
  {
    path: SITE.AUTOLOGIN,
    Component: TokenLogin,
    props: () => ({ conferencename: window.CONFERENCE_NAME }),
  },
  {
    path: SITE.PROFILE_EDIT,
    Component: ProfileEdit,
    providers: [AuthWall],
  },
  {
    path: SITE.PROFILE_ACCOUNT,
    Component: Profile,
    providers: [AuthWall],
    props: { isMe: true },
  },
  {
    path: SITE.PROFILE_NOTIFICATIONS,
    Component: ProfileNotificationSettings,
    providers: [AuthWall],
  },
  { path: SITE.ASK, Component: OpenASK },
];

export const siteFallbackRoute = {
  path: '*',
  Component: BundleRoute,
  props: { bundle: 'site' },
};
